import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCircle2, Printer } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { formatDateTime } from '../../lib/dateUtils';
import { API_URL, auth, errMsg } from './financeApi';

const ReceiptCard = ({ r }) => (
  <div className="rounded-2xl border-2 border-dashed border-emerald-300 bg-emerald-50/60 p-5 space-y-2" data-testid={`receipt-${r.month}`}>
    <div className="flex items-center justify-between gap-2">
      <p className="font-heading font-bold text-emerald-900 flex items-center gap-2"><CheckCircle2 className="w-5 h-5" /> Payment received</p>
      <span className="text-xs font-mono text-muted-foreground" data-testid={`receipt-no-${r.month}`}>{r.receipt_no}</span>
    </div>
    <p className="text-sm"><span className="text-muted-foreground">Child:</span> <strong>{r.kid_name}</strong></p>
    <p className="text-sm"><span className="text-muted-foreground">Month:</span> <strong data-testid={`receipt-month-${r.month}`}>{r.month_label}</strong></p>
    {r.school_name && <p className="text-sm"><span className="text-muted-foreground">School:</span> {r.school_name}</p>}
    <p className="text-sm"><span className="text-muted-foreground">Transport Operator:</span> {r.operator_name}</p>
    <p className="text-xs text-muted-foreground">Issued {formatDateTime(r.issued_at)} · NtwanaYam</p>
  </div>
);

export const ReceiptDialog = ({ kid, token, onClose }) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!kid) return;
    setRows(null);
    axios.get(`${API_URL}/parent/receipts`, { ...auth(token), params: { kid_id: kid.kid_id } })
      .then((r) => setRows(r.data))
      .catch((e) => toast.error(errMsg(e, 'Could not load receipts')));
  }, [kid, token]);

  return (
    <Dialog open={!!kid} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="receipt-dialog">
        <DialogHeader>
          <DialogTitle>Receipts · {kid?.full_name}</DialogTitle>
          <DialogDescription>A receipt is issued when a month's transport fee is fully paid.</DialogDescription>
        </DialogHeader>
        {!rows && <p className="text-sm text-muted-foreground">Loading…</p>}
        {rows && rows.length === 0 && <p className="text-sm text-muted-foreground" data-testid="receipt-empty">No receipts yet.</p>}
        <div className="space-y-3 print:space-y-6">{rows?.map((r) => <ReceiptCard key={r.receipt_no} r={r} />)}</div>
        {rows && rows.length > 0 && (
          <Button variant="outline" className="rounded-full w-fit" onClick={() => window.print()} data-testid="receipt-print-btn"><Printer className="w-4 h-4 mr-1" /> Print</Button>
        )}
      </DialogContent>
    </Dialog>
  );
};
